import {cx} from "@emotion/css";

import {designColors} from "~/ui";
import {ReactComponent as SvgUsers} from "~/assets/svg/users.svg";

import {simpleIconStyles} from "../styles";
import {commonStyles} from "../../_common/styles";
import {IIconBase} from "../../_common/types";

export const BmUsersIcon: React.FC<IIconBase> = ({id, size = "sm", color = designColors.black, className}) => {
  return <SvgUsers id={id} className={cx(simpleIconStyles(size), commonStyles.color(color), className)} />;
};
